import TYPES from '../../types';

// Domain
import { CustomerAddressDto } from '../../domain/dtos/customer-address-dto';
import { CustomerAddressRepository } from '../../domain/repositories/customer-address-repository';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import Command from '@/modules/shared/domain/use-cases/command';

@Injectable()
export default class UpdateCustomerAddressCommand extends Command<CustomerAddressDto> {
  @Inject(TYPES.CUSTOMER_ADDRESS_REPOSITORY)
  private readonly repository!: CustomerAddressRepository;

  internalExecute(payload: CustomerAddressDto): Promise<void> {
    return this.repository.update(payload);
  }
}
